/**
 * @vuepress
 * ---
 * title: Purchase Tracking Report
 */

import Transformer from '../transformer'
import { attachMissingCurrentTime } from '@/utils/moment'
import { parentPrefixTransformer } from '@/transformers/utils'

const conceptTransform = ({
  description,
  id,
  kind,
  quantity,
  total,
  unit_price: unitPrice
}) => {
  return {
    description,
    id,
    kind,
    quantity,
    total,
    unitPrice
  }
}
const freightTransform = ({
  id,
  amount,
  drag_guide: dragGuide,
  freight_provider: freightProvider,
  freight_provider_id: freightProviderId,
  comment
}) => {
  return {
    id,
    freightProvider,
    freightProviderId,
    dragGuide,
    amount,
    comment
  }
}

const requisitionTransform = ({
  date_requisition: dateRequisition,
  folio,
  tentative_delivery_date: tentativeDeliveryDate,
  id
}) => {
  return {
    dateRequisition,
    folio,
    tentativeDeliveryDate,
    id
  }
}

class sinisterTransformer extends Transformer {
  static fetch({
    actual_delivery_days: actualDeliveryDays,
    business_unit: businessUnit,
    collection_date: collectionDate,
    concepts = [],
    cost_total: costTotal,
    cost_without_vat: costWithoutVat,
    customer,
    days_rec_supervisor: daysRecSupervisor,
    delivery_days: deliveryDays,
    discount_without_vat: discountWithoutVat,
    division_name: divisionName,
    freights = [],
    notification_date: notificationDate,
    oc_status: ocStatus,
    status,
    oldest_payment_date: oldestPaymentDate,
    provider_name: providerName,
    purchase_order_id: purchaseOrderId,
    sinister_number: sinisterNumber,
    sinister_slug: sinisterSlug,
    sinister_status: sinisterStatus,
    supervisor,
    tentative_delivery_date: tentativeDeliveryDate,
    date_oc: dateOC,
    invoice,
    requisition,
    folio,
    oc_is_return: isReturn,
    oc_folio: ocFolio
  }) {
    return {
      actualDeliveryDays,
      businessUnit,
      collectionDate,
      costTotal,
      costWithoutVat,
      customer,
      daysRecSupervisor,
      deliveryDays,
      discountWithoutVat,
      divisionName,
      notificationDate,
      ocStatus: ocStatus || status,
      oldestPaymentDate,
      providerName,
      purchaseOrderId,
      sinisterNumber,
      sinisterSlug,
      sinisterStatus,
      supervisor,
      tentativeDeliveryDate,
      dateOC,
      concepts: concepts.length ? concepts.map((c) => conceptTransform(c)) : [],
      freights: freights.length ? freights.map((f) => Array.isArray(f) ? freightTransform(f) : f) : [],
      invoice,
      folio: ocFolio || folio,
      isReturn,
      ...parentPrefixTransformer('requisition', requisition ? requisitionTransform(requisition) : {})
    }
  }

  static send({
    notificationDate,
    actualDeliveryDays,
    collectionDate,
    status,
    isReturn
  }) {
    return {
      notification_date: attachMissingCurrentTime(notificationDate),
      actual_delivery_days: +actualDeliveryDays,
      status,
      is_return: isReturn,
      collection_date: !isReturn ? attachMissingCurrentTime(collectionDate) : undefined
    }
  }
}
export default sinisterTransformer
